import {
  Body,
  Box,
  CheckIcon,
  DecorationLine,
  Flex,
} from '@edreamsodigeo/prisma-design-system';
import React from 'react';

const SHADOW_SIZE = '40px';
const CIRCLE_SIZE = '24px';
const SUCCESS_CIRCLE_SIZE = '28px';

export const ChronologyItem = ({ children, type, last }) => (
  <Flex flexDirection="row" justifyContent="flex-start" alignItems="stretch">
    <DecorationLine
      decorationType={type}
      iconBackground={false}
      decorationSize="big"
      lineType={last ? 'none' : 'dashed'}
      lineGrey={true}
      alignTop={true}
      lineBottom="-10px"
      alignSelf="center"
    />
    <Box ml="1x_small" width="100%">
      {children}
    </Box>
  </Flex>
);

export const CircledBox = ({ number, color }) => (
  <BaseCircle border="2px solid" borderColor={color}>
    <Body
      data-testid="chrono-number"
      type="xSmall"
      weight="medium"
      color={color}
      textAlign="center"
    >
      {number}
    </Body>
  </BaseCircle>
);

export const CircledFillBox = ({ number, color }) => (
  <BaseCircle backgroundColor={color}>
    <ChronoShadowBox />
    <Body
      data-testid="chrono-fill-number"
      type="xSmall"
      weight="medium"
      color="neutral.0"
      textAlign="center"
    >
      {number}
    </Body>
  </BaseCircle>
);

export const CheckedBox = () => (
  <BaseCircle backgroundColor="green.50" size={SUCCESS_CIRCLE_SIZE}>
    <Box pt="2px">
      <CheckIcon
        data-testid="chrono-check"
        size="small"
        color="neutral.0"
        textAlign="center"
      ></CheckIcon>
    </Box>
  </BaseCircle>
);

function BaseCircle({
  size = CIRCLE_SIZE,
  fillColor = 'neutral.0',
  children,
  ...props
}) {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      height={size}
      width={size}
      backgroundColor={fillColor}
      borderRadius="50%"
      {...props}
    >
      {children}
    </Flex>
  );
}

const shadowBoxProps = {
  height: SHADOW_SIZE,
  width: SHADOW_SIZE,
  backgroundColor: 'inherit',
  borderRadius: 'inherit',
  position: 'absolute',
  sx: {
    zIndex: '-1',
  },
};

function ChronoShadowBox() {
  return (
    <Box
      {...shadowBoxProps}
      sx={{
        zIndex: '-1',
        opacity: '0.2',
      }}
    />
  );
}
